<!--已结案 caseclosed -->
<template>
  <div>
    <!-- E 搜索栏 -->
    <QuestionArea
      :belong-to="true"
      :problem-status="4"
      :enable-create="false"
      :enable-updown="false"
      :enable-delete="false"
      :data-source="dataSource"
      :getColproblemManagement="getColproblemManagement"
      @eventcol="eventcol"
      :moreLoading="moreLoading"
      :busy="busy"
      :totalCount="totalCount"
    />
  </div>
</template>

<script>
import QuestionArea from '@/components/QuestionArea/index.vue';
import { problemManagement } from '@/api/question';
import moment from 'moment';
import {
  questionStatus, questionLabel, questionColors, questTypeN, questTypeV, questionStatusN, questionStatusV, issueLevelV, issueColorN,
} from '@/api/constValue';
import { getSplitFiles } from '@/api/util';
import Bus from '@/views/Home/Status/bus';

export default {
  name: 'caseclosed',
  components: {
    QuestionArea,
  },
  data() {
    return {
      dataSource: [],
      quesType: '7',
      pageNo:1,
      moreLoading:false,
      busy:false,
      totalCount:'',
    };
  },
  created() {
    Bus.$emit('showhead', '0');
    Bus.$emit('headtext', '重点项目已结案问题');
    this.getColproblemManagement()
  },
  methods: {
    eventcol(data){
      this.pageNo = data
    },
    getColproblemManagement(){
      this.moreLoading = true
      Promise.all([problemManagement(this.$store.state.auth.userInfo.token, this.quesType,'','',this.pageNo)])
      .then(([questions]) => {
        const {data} = questions.data
        // console.log(questions,data)
        if (questions.data.errCode === '200' ) {
          if (questions.data.data.list.length == 0 && data.totalCount !=0) {
            this.$message.warning('没有更多数据了！');
            this.busy = true;
            return;
          }else if(questions.data.data.list.length == 0){
             this.busy = true;
             return;
          }
          this.totalCount = data.totalCount
          this.dataSource = this.dataSource.concat(questions.data.data.list.map((item) => {
            item.issueType = questTypeN[questTypeV.indexOf(item.issueType)];
            item.issueFile = getSplitFiles(item.issueFile);
            item.endFile = getSplitFiles(item.endFile);
            item.checkFile = getSplitFiles(item.checkFile);
            item.processList = item.processList.map((i) => {
              i.problemStatus = questionStatusN[questionStatusV.indexOf(i.problemStatus)];
              i.processFile = getSplitFiles(i.processFile)
              return i;
            });
            Object.assign(item, {
              status: '2',
            });
            if (item.nodeProblemStatus === '7' || item.nodeProblemStatus === '8') {
              item.status = '3';
            } else if (item.deadlineDt && (moment(item.deadlineDt).diff(new Date()) < 0)) {
              item.status = '1';
            } else {
              item.status = '2';
            }
            Object.assign(item, {
              detail: item.processList,
            });
            return item
          }));
          this.moreLoading = false
        }else if (questions.data.errCode == "err0000") {
               this.$message.error('内部服务异常');
              } else if(questions.data.errCode == "err0002"){
               this.$message.error('登录过期，请重新登录');
               this.$router.push('/login');
              }
      });
    }
  },
};
</script>

<style scoped lang="less">
@import "../../../assets/styles/index.less";
.question {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  background: @color-card-bg;

  &__search-bar {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-content: center;

    input {
      width: 280px;
    }
  }
}
</style>
